<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="患者姓名" prop="patientName">
        <Input v-model="editModel.patientName"></Input>
      </FormItem>
      <FormItem label="姓名拼音" prop="patientNameSpell">
        <Input v-model="editModel.patientNameSpell"></Input>
      </FormItem>
      <FormItem label="生日" prop="patientBirthday">
        <Input v-model="editModel.patientBirthday"></Input>
      </FormItem>
      <FormItem label="性别">
        <Select class="w-250" v-model="editModel.patientSex" clearable>
          <Option value="M">男 </Option>
          <Option value="F">女 </Option>
        </Select>
      </FormItem>
      <!-- <FormItem label="性别" prop="patientSex">
        <Input v-model="editModel.patientSex" ></Input>
      </FormItem> -->
      <FormItem label="身份证号" prop="idCardNO">
        <Input v-model="editModel.idCardNO"></Input>
      </FormItem>
      <FormItem label="手机号" prop="telePhone">
        <Input v-model="editModel.telePhone"></Input>
      </FormItem>
      <FormItem label="证件号" prop="identityID">
        <Input v-model="editModel.identityID"></Input>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="editModel.email"></Input>
      </FormItem>
      <FormItem label="医保号" prop="insuranceID">
        <Input v-model="editModel.insuranceID"></Input>
      </FormItem>
      <FormItem label="职业" prop="occupation">
        <Input v-model="editModel.occupation"></Input>
      </FormItem>
      <FormItem label="工作单位" prop="addressWork">
        <Input v-model="editModel.addressWork"></Input>
      </FormItem>
    </Form>

    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
import token from "../../../utils/token.js";
export default {
  props: ["currentData"],
  data: function () {
    return {
      ServiceSelect: [],
      fileName: "",
      headers: "",
      uploadUrl: "",
      editModel: {},
      SecretTypeSelect: [],
      ruleValidate: {
        VersionName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.SecretTypeSelect = this.$common.getJsonData("clientType");
    let baseUrl = localStorage.getItem("baseURL");

    this.headers = { Authorization: "Bearer " + token.getToken() };

    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("patient/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
  },
};
</script>
<style scoped>
.limitshow {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>